import PropTypes from 'prop-types';

function IFPetsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M9.08127 13.6252C9.08127 13.6252 7.28425 25.1775 7.83619 25.6481C8.38813 26.1188 12.9705 28.2752 21.5919 26.3027C28.5447 24.7111 32.3912 22.0712 33.756 19.8035C34.308 19.1617 27.9799 9.23535 27.9799 9.23535L9.08127 13.6252Z"
                fill="#F7D46D"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M19.2577 14.6201C24.4694 13.4121 28.3638 11.0071 27.9562 9.24834C27.5485 7.48962 22.9931 7.04318 17.7814 8.25119C12.5697 9.45919 8.6753 11.8642 9.08295 13.6229C9.49059 15.3816 14.046 15.8281 19.2577 14.6201Z"
                fill="white"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.0267 18.9179C24.345 18.8443 24.6343 18.678 24.858 18.4399C25.0817 18.2019 25.2299 17.9029 25.2837 17.5807C25.3375 17.2585 25.2945 16.9276 25.1602 16.6298C25.0259 16.332 24.8063 16.0807 24.5292 15.9078C24.252 15.7348 23.9299 15.6479 23.6033 15.658C23.2768 15.6682 22.9607 15.7749 22.6948 15.9648C22.429 16.1546 22.2254 16.419 22.1099 16.7246C21.9943 17.0301 21.972 17.3631 22.0457 17.6814C22.0666 17.7726 22.0967 17.8615 22.1355 17.9466L17.4291 19.0377C17.4225 18.9442 17.4097 18.8513 17.3906 18.7596C17.3159 18.4504 17.1536 18.1693 16.9231 17.9501C16.6926 17.7309 16.4037 17.583 16.0912 17.524C15.7786 17.4651 15.4557 17.4976 15.1612 17.6178C14.8667 17.738 14.6131 17.9406 14.431 18.2014C14.2489 18.4622 14.146 18.77 14.1346 19.0879C14.1232 19.4057 14.2039 19.7201 14.3669 19.9933C14.5299 20.2664 14.7683 20.4867 15.0534 20.6276C15.3386 20.7685 15.6584 20.8241 15.9743 20.7876C15.6715 20.8906 15.4051 21.0793 15.2075 21.3308C15.0098 21.5823 14.8895 21.8858 14.861 22.2043C14.8326 22.5229 14.8973 22.8429 15.0472 23.1255C15.1972 23.408 15.4259 23.6409 15.7057 23.7959C15.9855 23.9509 16.3043 24.0213 16.6233 23.9986C16.9424 23.9759 17.2479 23.861 17.503 23.668C17.758 23.4749 17.9514 23.2119 18.0598 22.911C18.1682 22.6101 18.1869 22.2841 18.1136 21.9728C18.0922 21.8822 18.0636 21.7935 18.0281 21.7075L22.7345 20.6165C22.7414 20.7099 22.7542 20.8028 22.7731 20.8946C22.8466 21.2129 23.013 21.5022 23.251 21.7259C23.489 21.9496 23.788 22.0978 24.1102 22.1516C24.4324 22.2054 24.7634 22.1624 25.0611 22.0281C25.3589 21.8938 25.6102 21.6742 25.7832 21.3971C25.9561 21.1199 26.0431 20.7978 26.0329 20.4713C26.0228 20.1447 25.916 19.8286 25.7262 19.5627C25.5363 19.2969 25.2719 19.0933 24.9663 18.9778C24.6608 18.8622 24.3278 18.8399 24.0096 18.9136L24.0267 18.9179Z"
                fill="#E95CA2"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5471 15.2511C12.9493 14.4681 17.5445 10.1809 24.9551 12.3758C19.1233 15.6533 12.5471 15.2511 12.5471 15.2511Z"
                fill="#453D3D"
            />
        </svg>
    );
}

export default IFPetsActive;

IFPetsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFPetsActive.defaultProps = {
    className: null,
};
